import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "animate.css/animate.min.css";
import { WOW } from "wowjs";

import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import LoadTop from "../components/ScrollToTop/LoadTop";

import { Home, CourseOne, CourseDetails, Service, SignIn, SignUp } from "../pages";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  //preloader
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  //Initialize wow
  useEffect(() => {
    new WOW({ live: false, animateClass: "animate__animated" }).init();
  }, [location]);

  return (
    <div className="App">
      {isLoading && <Preloader />}
      <ScrollToTop />
      <LoadTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/course-1" element={<CourseOne />} />
        <Route path="/course-details" element={<CourseDetails />} />
        <Route path="/services-1" element={<Service />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
